<ion-header [hidden]="global.scanCamera">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title></ion-title>
        <ion-buttons slot="start">
            <ion-item>
                <ion-button (click)="chDD(-1)">
                    <ion-icon name="caret-back-outline"></ion-icon>
                </ion-button>
                {{DDtxt}}
                <ion-button (click)="chDD(+1)">
                    <ion-icon name="caret-forward-outline"></ion-icon>
                </ion-button>
            </ion-item>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="tab==='dag'"  [hidden]="global.scanCamera">
    <ion-grid>
        <ion-row>
            <ion-col size="auto">
                <ion-button expand="block" (click)="startDag()" *ngIf="!TStartDag && uren.length==0">
                    <ion-icon name="caret-forward-circle" size="large"></ion-icon>Start dag
                </ion-button>
            </ion-col>
            <ion-col size="auto">
                <ion-button expand="block" (click)="addUren()">
                    <ion-icon name="add-circle" size="large"></ion-icon>Nieuw
                </ion-button>
            </ion-col>
            <ion-col size="auto">
                <ion-button expand="block" (click)="setTab('week')">
                    <ion-icon name="calendar-outline" size="large"></ion-icon>per week
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>

    <mat-card>
        <ion-checkbox *ngFor="let f of fields" [(ngModel)]="werktijden[f.fld]" (ionChange)="changeField()"
            [name]="f.fld"
            [disabled]="werktijden.allowEdit=='0'"
            labelPlacement="end" justify="start"
        >{{f.descr}}</ion-checkbox>
        <table class='afstand' *ngIf="uren.length>0">
            <tr>
                <th></th>
                <th>Uren</th>
                <th>Order</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
            <tr *ngFor="let lin of uren">
                <td align="right">{{lin.Tend}}<br>
                    {{lin.Tstart}}</td>
                <td *ngIf="lin.allowEdit=='1'" align="right" class='link' (click)="editUren(lin.ID)">{{lin.Uren}}</td>
                <td *ngIf="lin.allowEdit=='0'" align="right">{{lin.Uren}}</td>
                <td>{{lin.OrderNr}}</td>
                <td>{{lin.Uursoort}}</td>
                <td>{{lin.Omschr}}</td>
                <td><ion-icon name="checkmark" style="color: green;" *ngIf="lin.Accoord=='J'"></ion-icon></td>
                <td>{{lin.Aanpassing}}</td>
            </tr>
            <tr>
                <td></td>
                <td align="right"><b>{{total}}</b></td>
            </tr>
        </table>
        <p *ngIf="uren.length==0 && TStartDag">Dag gestart om {{TStartDag}}.</p>
    </mat-card>
</ion-content>

<ion-content *ngIf="tab==='week'" [hidden]="global.scanCamera">
    <ion-grid>
        <ion-row>
            <ion-col size="auto">
                <ion-button expand="block" (click)="setTab('dag')">
                    <ion-icon name="calendar-number-outline" size="large"></ion-icon>per dag
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
    <mat-card>
        <table class='afstand' *ngIf="week && week.rows && week.rows.length>0">
            <tr>
                <th *ngFor="let h of week.hdr">{{h}}</th>
            </tr>
            <tr *ngFor="let row of week.rows">
                <td *ngFor="let c of row | keyvalue | slice:0:1" class="link" (click)="setDD(c.value)">{{c.value}}</td>
                <td *ngFor="let c of row | keyvalue | slice:1" align="right">{{c.value}}</td>
            </tr>
            <tr>
                <td *ngFor="let f of week.ftr | slice:0:1">{{f}}</td>
                <td *ngFor="let f of week.ftr | slice:1:2" align="right">{{f}}</td>
                <td *ngFor="let f of week.ftr | slice:2" align="right" style="border-top: 1px solid;">{{f}}</td>
            </tr>
        </table>
        <p>{{msg}}</p>
    </mat-card>
</ion-content>
